import { render, staticRenderFns } from "./UserContestSummary.vue?vue&type=template&id=55921489&"
import script from "./UserContestSummary.vue?vue&type=script&lang=js&"
export * from "./UserContestSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports